import { Container, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomImage from "../../../common/components/image/CustomImage";
import styled from "styled-components";
import { useRef, useState } from "react";
import { useClickOutside } from "../../../common/hooks/useClickOutside";
import { C2Text } from "../../../common/components/text/CustomText";
import CustomIcon from "../../../common/components/image/CustomIcon";
import LanguageDropdownMenu, { Languages } from "../../../common/components/dropdown/LanguageDropdownMenu";
import LocalStorageKey from "../../../common/enums/LocalStorageKey";
import { Theme } from "../../../common/Theme";

const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export default function LanguageSelector() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [currentLanguage] = useState(() => localStorage.getItem(LocalStorageKey.language) || "en");

    const menuRef = useRef(null);
    const buttonRef = useRef(null); // 버튼의 위치를 추적하기 위한 ref

    useClickOutside(menuRef, (event) => {
        if (isMenuOpen) {
            // LanguageDropdownMenu가 Portal을 사용하므로, 클릭된 요소가 menuRef 내부에 없더라도
            // 드롭다운 내부에 있는지 확인해야 함
            const dropdown = document.querySelector('[data-is-dropdown="true"]');
            if (dropdown && dropdown.contains(event.target)) {
                return;
            }
            setIsMenuOpen(false);
        }
    });

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const handleLanguageChange = (newLang) => {
        localStorage.setItem(LocalStorageKey.language, newLang);
        window.location.reload();
    };

    return (
        <MenuContainer ref={menuRef}>
            <Row cursor={"pointer"} onClick={toggleMenu} ref={buttonRef}>
                <Container
                    padding={"6px"}
                    borderRadius={"100%"}
                    border={`1px solid ${Theme.color.neutral200}`}
                    cursor={"pointer"}
                    onClick={toggleMenu}
                    hoverBackgroundColor={Theme.color.neutral100}
                >
                    <CustomImage
                        imageName={
                            Languages.filter((v) => {
                                return v.value === currentLanguage;
                            })[0]?.image
                        }
                        size={"24px"}
                        cursor={"pointer"}
                        borderRadius={"100%"}
                    />
                </Container>
                <SizedBox width={"10px"} />
                <C2Text>
                    {
                        Languages.filter((v) => {
                            return v.value === currentLanguage;
                        })[0]?.label
                    }
                </C2Text>
                <SizedBox width={"10px"} />
                <CustomIcon iconName={isMenuOpen ? "chevron_up" : "chevron_down"} size={"16px"} cursor={"pointer"} />
            </Row>
            {isMenuOpen && (
                <LanguageDropdownMenu
                    initValue={currentLanguage}
                    setValue={handleLanguageChange}
                    values={Languages}
                    onClose={toggleMenu}
                    anchorEl={buttonRef.current} // 버튼 엘리먼트를 prop으로 전달
                    placement="bottom-start" // 왼쪽 정렬
                />
            )}
        </MenuContainer>
    );
}
